/******************************************************************************************
 *	Cancel PA Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.cancelCustomerInvitationModal', [])
    .factory(
      'CancelCustomerInvitationModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/cancel-customer-invitation-modal.html',
          controller: 'CancelCustomerInvitationModalController',
          classNames: 'cancel-customer-invitation-modal'
        });
      }
    )
    .controller(
      'CancelCustomerInvitationModalController',
      /* @ngInject */
      function($log, $scope, CancelCustomerInvitationModal, CurtainNotifications, CustomerInvitation) {
        //Submit
        var resetSubmit = function() {
          CancelCustomerInvitationModal.unsetLoadingState();
          $scope.submitted = false;
        };

        $scope.submit = function() {
          if (!$scope.submitted) {
            $scope.submitted = true;
            CancelCustomerInvitationModal.setLoadingState();

            //DELETE Call
            CustomerInvitation.cancel($scope.customerID, $scope.purchaseID)
              .then(function(responseData) {
                CurtainNotifications.show(
                  CurtainNotifications.SUCCESS,
                  'cancelCustomerInvitationModal.notifications.submitSuccess',
                  {name: $scope.name}
                );
                CancelCustomerInvitationModal.remove({
                  response: responseData
                });
              })
              .catch(function(response) {
                if (response.status !== 0) {
                  //status is 0 when call is aborted
                  //Get first character from HTTP status as number
                  var statusType = +('' + response.status).charAt(0);

                  if (statusType === 4) {
                    if (response.data.errorCode === 'INVITE_ALREADY_ACCEPTED') {
                      CurtainNotifications.show(
                        CurtainNotifications.NOTICE,
                        'cancelCustomerInvitationModal.notifications.invitationAlreadyAccepted'
                      );
                      CancelCustomerInvitationModal.remove({cancelled: true, needsRefresh: true});
                    } else if (response.data.errorCode === 'INVITE_ALREADY_CANCELLED') {
                      CurtainNotifications.show(
                        CurtainNotifications.NOTICE,
                        'cancelCustomerInvitationModal.notifications.invitationAlreadyCancelled'
                      );
                      CancelCustomerInvitationModal.remove({cancelled: true, needsRefresh: true});
                    } else {
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'generic.notifications.error'
                      );
                      resetSubmit();
                      $log.error('Failed to cancel the invite', response.data);
                    }
                  } else if (statusType === 5) {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                    resetSubmit();
                    $log.error('Failed to cancel the invite', response.data);
                  }
                }
              });
          }
        };

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          CancelCustomerInvitationModal.remove({cancelled: true});
        };
      }
    );
})();
